import React, { useEffect, useLayoutEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { LOTTO_CONSTANTS } from '../../constants';
import classes from './FlyToCartAnimation.module.scss';

const FlyToCartAnimation = ({ sourceElement, targetElement, onComplete }) => {
  const [animationStyles, setAnimationStyles] = useState(null);
  const [isReady, setIsReady] = useState(false);

  useLayoutEffect(() => {
    if (!sourceElement || !targetElement) {
      onComplete();
      return;
    }

    const sourceRect = sourceElement.getBoundingClientRect();
    const targetRect = targetElement.getBoundingClientRect();

    setAnimationStyles({
      startX: sourceRect.left + sourceRect.width / 2 - 30,
      startY: sourceRect.top + sourceRect.height / 2 - 20,
      endX: targetRect.left + targetRect.width / 2 - 30,
      endY: targetRect.top + targetRect.height / 2 - 20,
    });
    setIsReady(true);
  }, [sourceElement, targetElement, onComplete]);

  useEffect(() => {
    if (!animationStyles) return undefined;
    const timer = setTimeout(onComplete, LOTTO_CONSTANTS.ANIMATION_DURATION);
    return () => clearTimeout(timer);
  }, [animationStyles, onComplete]);

  if (!animationStyles || !isReady) return null;

  const { startX, startY, endX, endY } = animationStyles;
  const deltaX = endX - startX;
  const deltaY = endY - startY;

  return (
    <motion.div
      className={classes.FlyingTicket}
      style={{ left: startX, top: startY }}
      initial={{ x: 0, y: 0, scale: 1, opacity: 1 }}
      animate={{
        x: [0, deltaX * 0.55, deltaX],
        y: [0, deltaY * 0.55 - 60, deltaY],
        scale: [1, 0.85, 0.35],
        opacity: [1, 0.9, 0],
      }}
      transition={{
        duration: LOTTO_CONSTANTS.ANIMATION_DURATION / 1000,
        ease: 'linear',
        times: [0, 0.55, 1],
      }}
      onAnimationComplete={onComplete}
    />
  );
};

export default FlyToCartAnimation;
